import {useAppDispatch} from "config/store";
import {authActions} from "config/store/modules/auth.ts";
import {tryAsyncFunc} from "globals/functions/async.ts";
import ajax from "config/ajax.ts";
import {useLocation, useNavigate} from "react-router-dom";
import {Form, Formik} from "formik";
import Button from "components/atom/button/Button.tsx";
import LoadingContainer from "components/container/LoadingContainer.tsx";
import Input from "components/atom/Input.tsx";
import {useTranslation} from "react-i18next";
import messagesPng from 'assets/images/messages.png'
import {useCallback, useRef} from "react";

function VerifyEmail() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const {t} = useTranslation()
    const formikRef = useRef<any>(null)


    const values = {
        email: '',
        code: '',
    }

    //if we redirect from other page
    if (location.state && location.state.email && typeof location.state.email === 'string') {
        values.email = location.state.email
    }

    const resendCode = useCallback(async () => {
        const [_, err] = await tryAsyncFunc(ajax.post('/connected/auth/resend-code'))

        if (err) {
            if (err.response.status === 429) {
                formikRef.current?.setStatus(t('forms.errors.resendCodeErrorRateLimit'))
            } else {
                formikRef.current?.setStatus(t('forms.errors.resendCodeError'))
            }
            return
        }
    }, [t])

    return (
        <div className="w-full">
            <img src={messagesPng} className="mx-auto block h-[220px] w-auto"/>
            <h2 className="pb-3 text-center font-semibold">
                {t('auth.verifyEmailTitle')}
            </h2>
            <p className="pb-6 text-center text-gray-400">
                {t('auth.verifyEmailDescription')}
            </p>
            <Formik
                innerRef={formikRef}
                initialValues={values}
                validateOnChange={false}
                validateOnBlur={false}
                validate={values => {
                    const errors: Partial<{ [K in keyof typeof values]: string }> = {};//same keys as type but with string value
                    if (!values.code) {
                        errors.code = t('forms.errors.code')
                    }
                    return errors;
                }}
                onSubmit={async (values, {setSubmitting, setStatus, setFieldError}) => {
                    setSubmitting(true);
                    setStatus(null)

                    const [res, err] = await tryAsyncFunc(ajax.post('/connected/auth/verify-email', {
                        email: values.email,
                        code: parseInt(values.code),
                    }))
                    setSubmitting(false);

                    if (err) {
                        const errData = err.response.data || {}
                        const errors = errData.errors || {}
                        if (errors.global) {
                            setStatus(errors.global)
                            delete errors.global
                        }

                        Object.keys(errors).forEach(errKey => {
                            setFieldError(errKey, errors[errKey])
                        })
                        return
                    }

                    //update user with new data
                    await dispatch(authActions.setUser(res.data.user))

                    if (location.state && location.state.redirect_to && location.state.redirect_to !== '/profile') {
                        window.location.href = location.state.redirect_to//hard refresh
                        return
                    }

                    navigate('/profile')
                }}
            >
                {({isSubmitting, status}) => (
                    <LoadingContainer isLoading={isSubmitting} keepChildren>
                        <Form>
                            <Input name="code" type="number" label={t('forms.code')}/>

                            <div>
                                <button type="button" onClick={resendCode} className="text-xs underline">
                                    {t('auth.resendCode')}
                                </button>
                            </div>
                            {status && (
                                <p className="error block">{status}</p>
                            )}
                            <div className="mt-4 flex w-full flex-row items-center justify-center">
                                <Button className="w-full" type="submit" disabled={isSubmitting}>
                                    {t('auth.validate')}
                                </Button>
                            </div>
                        </Form>
                    </LoadingContainer>
                )}
            </Formik>
        </div>
    )
}

export default VerifyEmail
